const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export function printItensCliente({ montagem, clienteNome, getMaterialNome, getMaterialCodigo }) {
  const grouped = {};
  for (const it of montagem.itens || []) {
    const key = it.material_id || 'diverso';
    grouped[key] = (grouped[key] || 0) + (it.quantidade || 1);
  }
  const rows = Object.entries(grouped);
  const total = rows.reduce((s, [, q]) => s + q, 0);
  const fmt = (d) => d ? new Date(d).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }) : '-';
  const recepcao = (montagem.observacoes || '').match(/REC-\d+/)?.[0] || '-';

  const html = `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8"><title>Itens - ${esc(clienteNome)}</title>
<style>
@page { size: A4; margin: 15mm; }
body { font-family: Arial, sans-serif; color: #111; font-size: 12px; }
h1 { font-size: 18px; margin: 0 0 4px; } .sub { color: #555; margin-bottom: 14px; }
.info { display: grid; grid-template-columns: 1fr 1fr; gap: 6px 20px; border: 1px solid #ccc; padding: 10px; border-radius: 4px; margin-bottom: 14px; }
.info b { display: inline-block; min-width: 110px; }
table { width: 100%; border-collapse: collapse; }
th, td { border: 1px solid #bbb; padding: 6px 8px; text-align: left; }
th { background: #f1f1f1; } td.q, th.q { text-align: center; width: 90px; } td.c { width: 30px; text-align: center; }
tfoot td { font-weight: bold; background: #fafafa; }
.sign { display: flex; gap: 40px; margin-top: 60px; } .sign div { flex: 1; border-top: 1px solid #333; text-align: center; padding-top: 4px; }
.foot { margin-top: 24px; font-size: 10px; color: #777; }
</style></head><body>
<h1>Conferência de Itens Recebidos</h1>
<div class="sub">Etapa: Montagem</div>
<div class="info">
<div><b>Cliente:</b> ${esc(clienteNome)}</div>
<div><b>Montagem:</b> ${esc(montagem.numero_montagem)}</div>
<div><b>Recepção:</b> ${esc(recepcao)}</div>
<div><b>Data:</b> ${esc(fmt(montagem.created_at))}</div>
</div>
<table><thead><tr><th class="c">#</th><th>Código</th><th>Material</th><th class="q">Quantidade</th><th class="q">Conferido</th></tr></thead>
<tbody>${rows.map(([id, q], i) => `<tr><td class="c">${i + 1}</td><td>${esc(getMaterialCodigo(id))}</td><td>${esc(getMaterialNome(id))}</td><td class="q">${q}</td><td class="q">☐</td></tr>`).join('')}</tbody>
<tfoot><tr><td colspan="3">Total: ${rows.length} material(is)</td><td class="q">${total}</td><td></td></tr></tfoot></table>
<div class="sign"><div>Responsável pela Montagem</div><div>Conferido por</div></div>
<div class="foot">Impresso em ${esc(fmt(new Date()))}</div>
<script>window.onload = () => { window.print(); };</script>
</body></html>`;

  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  return true;
}
